import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  exportExcel,
  addProcessRemark,
  confirmStopSim,
  reopeningSim,
  getExcelReport
} from '@/api/stopsimcarddataanalysisresultserv'

export default {
  state: {
    state_StopSimCardDataAnalysisResult_GetAllResult: null,
    state_StopSimCardDataAnalysisResult_SearchByNameResult: null,
    state_StopSimCardDataAnalysisResult_GetPageResult: null,
    state_StopSimCardDataAnalysisResult_GetDetailResult: null,
    state_StopSimCardDataAnalysisResult_ExportExcelResult: null,
    state_StopSimCardDataAnalysisResult_AddProcessRemarkResult: null,
    state_StopSimCardDataAnalysisResult_ConfirmStopSimResult: null,
    state_StopSimCardDataAnalysisResult_ReopeningSimResult: null,
    state_StopSimCardDataAnalysisResult_GetExcelReportResult: null
  },
  mutations: {
    SET_STOPSIMCARDDATAANALYSISRESULT_GETALL_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_GetAllResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_SearchByNameResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_GetPageResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_GetDetailResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_ExportExcelResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_AddProcessRemarkResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_CONFIRMSTOPSIM_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_ConfirmStopSimResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_REOPENINGSIM_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_ReopeningSimResult = rst
    },
    SET_STOPSIMCARDDATAANALYSISRESULT_GETEXCELREPORT_RESULT: (state, rst) => {
      state.state_StopSimCardDataAnalysisResult_GetExcelReportResult = rst
    }
  },
  actions: {
    StopSimCardDataAnalysisResultServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_ExportExcel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_EXPORTEXCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_AddProcessRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_ConfirmStopSim ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmStopSim(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_CONFIRMSTOPSIM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_CONFIRMSTOPSIM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_ReopeningSim ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        reopeningSim(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_REOPENINGSIM_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_REOPENINGSIM_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    StopSimCardDataAnalysisResultServ_GetExcelReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getExcelReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETEXCELREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_STOPSIMCARDDATAANALYSISRESULT_GETEXCELREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_StopSimCardDataAnalysisResult_GetAllResult: state => {
      return state.state_StopSimCardDataAnalysisResult_GetAllResult
    },
    get_StopSimCardDataAnalysisResult_SearchByNameResult: state => {
      return state.state_StopSimCardDataAnalysisResult_SearchByNameResult
    },
    get_StopSimCardDataAnalysisResult_GetPageResult: state => {
      return state.state_StopSimCardDataAnalysisResult_GetPageResult
    },
    get_StopSimCardDataAnalysisResult_GetDetailResult: state => {
      return state.state_StopSimCardDataAnalysisResult_GetDetailResult
    },
    get_StopSimCardDataAnalysisResult_ExportExcelResult: state => {
      return state.state_StopSimCardDataAnalysisResult_ExportExcelResult
    },
    get_StopSimCardDataAnalysisResult_AddProcessRemarkResult: state => {
      return state.state_StopSimCardDataAnalysisResult_AddProcessRemarkResult
    },
    get_StopSimCardDataAnalysisResult_ConfirmStopSimResult: state => {
      return state.state_StopSimCardDataAnalysisResult_ConfirmStopSimResult
    },
    get_StopSimCardDataAnalysisResult_ReopeningSimResult: state => {
      return state.state_StopSimCardDataAnalysisResult_ReopeningSimResult
    },
    get_StopSimCardDataAnalysisResult_GetExcelReportResult: state => {
      return state.state_StopSimCardDataAnalysisResult_GetExcelReportResult
    }
  }
}
